import request from './service/index'

export function getUserList_Api(data){//查询列表
  return request({
      url:`CMS/statistics/user_list`,
      method:'post',
      data:data
  });
}


export function getUserDetail_Api(data){//查询用户
  return request({
      url:`CMS/statistics/user_detail`,
      method:'post',
      data:data
  });
}

export function getUserAct_Api(data){//查询用户
  return request({
      url:`CMS/statistics/user_act`,
      method:'post',
      data:data
  });
}

export function getUserData_Api(data){//查询用户
  return request({
      url:`CMS/statistics/all_statistics`,
      method:'post',
      data:data
  });
}




// WEBPACK FOOTER //
// ./src/apis/user.api.js